import React from 'react';
import { TaskListItem } from '../matchingInboxModels';
import Task from './Task';
import { styled } from '@mui/material';
import { isToday, isTomorrow } from 'date-fns';
import { formatShortWeekdayMonthDay } from 'shared/Dates';
import { Colors, Text } from 'library';

export default function GroupedTasks({
    group,
    tasks,
    refresh,
    onEdit,
}: {
    group: string;
    tasks: TaskListItem[];
    refresh: () => void;
    onEdit: (task: TaskListItem) => void;
}) {
    let title = 'No Due Date';
    if (group !== 'empty') {
        const today = isToday(new Date(group));
        const tomorrow = isTomorrow(new Date(group));
        title = today ? 'Today' : tomorrow ? 'Tomorrow' : formatShortWeekdayMonthDay(group);
    }
    return (
        <div>
            <Text
                variant="body1"
                bold
                color={Colors.turquoise}
                textStyle={{ marginBottom: 8, textDecoration: 'underline' }}
            >
                {title}
            </Text>
            {tasks.map((task) => (
                <Task
                    key={task.id}
                    task={task}
                    refresh={refresh}
                    noDivider={task.id === tasks[tasks.length - 1].id}
                    onEdit={onEdit}
                />
            ))}
            <FatDivider />
        </div>
    );
}

const FatDivider = styled('div')({
    width: '100%',
    height: 3,
    marginTop: 8,
    marginBottom: 8,
    backgroundColor: Colors.mediumGrey,
    borderRadius: 5,
});
